import { render, staticRenderFns } from "./SysMessage.vue?vue&type=template&id=a1c34992&scoped=true&"
import script from "./SysMessage.vue?vue&type=script&lang=js&"
export * from "./SysMessage.vue?vue&type=script&lang=js&"
import style0 from "./SysMessage.vue?vue&type=style&index=0&id=a1c34992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c34992",
  null
  
)

export default component.exports